module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_search_gray-6ee177ff021fd13adfdc037380bda490.svg";